import api from '../api'
import { compareIds } from '../common/utils'

const initialState = {
  isLoading: false,
  list: [],
  item: null,
  pagination: { page: 0, limit: 20, total: 0 },
}

const parsePagination = (value = '0/20/0') => {
  const values = value.split('/')
  return {
    page: parseInt(values[0], 10),
    limit: parseInt(values[1], 10),
    total: parseInt(values[2], 10),
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case api.getIngredientHeaders.request:
    case api.getIngredients.request:
      return {
        ...state,
        isLoading: true,
      }
    case api.getIngredientHeaders.success:
    case api.getIngredients.success:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        pagination: parsePagination(action.response.headers.pagination),
      }
    case api.getIngredientHeaders.failure:
    case api.getIngredients.failure:
      return {
        ...state,
        isLoading: false,
      }
    case api.getIngredient.request:
      return {
        ...state,
        item: null,
        isLoading: true,
      }
    case api.getIngredient.success:
      return {
        ...state,
        isLoading: false,
        item: action.payload,
      }
    case api.getIngredient.failure:
      return {
        ...state,
        isLoading: false,
      }
    case api.addIngredient.success:
      return {
        ...state,
        list: [...state.list, action.payload],
      }
    case api.deleteIngredient.success:
      return {
        ...state,
        list: state.list.filter(item => !compareIds(item.id, action.route)),
      }
    case api.updateIngredient.success:
      return {
        ...state,
        item: action.payload,
      }
    default:
      return state
  }
}
